import type { DrawnCard } from "../types";

export function CardFace({ card, revealed = true, compact = false }: { card?: DrawnCard; revealed?: boolean; compact?: boolean }) {
  if (!revealed || !card) return <div className={`tarot-card card-back ${compact ? "compact" : ""}`} aria-label="未翻开的答案卡"><span>✦</span><i>CAREER<br />CARDS</i></div>;
  return <article className={`tarot-card card-face ${card.reversed ? "reversed" : ""} ${compact ? "compact" : ""}`}>
    <div className="card-inner">
      <small>{card.position}</small>
      <span className="card-symbol">{card.symbol}</span>
      <div><h3>{card.name}</h3><p>{card.english}</p></div>
      <b>{card.orientation}</b>
    </div>
  </article>;
}
